<template>
  <div id="layout">
    <div class="main">
      <div class="head">
        <div class="logo">
          <img src="../components/img/header/icon_img1.png" alt="">
          Runway
          <div class="logoName">中文站</div>
        </div>
        <div class="head_right">
          <div class="objMv mR10">
            <img class="videoGif" src="./img/vip-icon.gif" alt=""/>
            <div class="objName" @click="toPlay('member')">
              升级
            </div>
          </div>
          <div class="objMv">
            <img class="videoImg" src="./img/videoPlayIco.png" alt=""/>
            <div class="objName" @click="toPlay('toPlay')">
              教程
            </div>
          </div>
        </div>
<!--        <div class="objMv">-->
<!--          <img class="videoImg" src="./img/videoPlayIco.png"/>-->

<!--          <div class="objName" @click="toPlay">-->
<!--            新手视频教程-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <!-- <transition name="fade-transform" mode="out-in"> -->
      <router-view></router-view>
      <!-- </transition> -->
    </div>
    <div class="tabbar" flex-align>
      <router-link :to="tab.link" class="tab_item" :class="tab.name==='会员'?'vip':''" flex-center
                   v-for="(tab, index) in tabList" :key="index">
        <img class="tab_icon" :src="tab.icon" alt="">
        <img class="tab_icon tab_active_icon" :src="tab.active_icon" alt="">
        {{ tab.name }}
      </router-link>
    </div>
    <!-- 登录弹窗 -->
    <!-- <Login v-if="show_login_compoments"></Login> -->
    <NewLoginPanel v-if="show_login_compoments"></NewLoginPanel>
    <!-- 修改绑定手机号 -->
    <BindPhone v-if="show_bindphone_compoments"></BindPhone>
    <!-- 激活码兑换 -->
    <CodeExchange v-if="show_code_exchange_compoments"></CodeExchange>
    <!-- 每日签到 -->
    <AttenDance v-if="show_attendance_compoments"></AttenDance>
    <!-- Vip 提示框 -->
    <toastVip v-if="show_toast_vip"
              @vipOpenHandle="vipOpenHandle"></toastVip>
    <PlayVideo ref="playVidRef"></PlayVideo>
    <HdProvisionalUpgrade ref="UpgradePopup"></HdProvisionalUpgrade>
    <RightFunPop></RightFunPop>
    <!-- 推广 -->
    <welcomeAd ref="welcomeAdPopup"></welcomeAd>


    <!-- ai提示词 -->
    <AIpromptWords ref="promptBox" v-if="isInputValshow"/>
    <!-- 右侧升级提示 -->
    <YouhuiPop @open_vip_pop="toUpeveVip" @newOpen_vip="showPayRetainPop"></YouhuiPop>
    <isEveVipPop></isEveVipPop>

    <!-- 恭喜你成为xxx会员弹框 -->
    <congratulations_on_becoming v-if="vip_congratulations_show"></congratulations_on_becoming>
    <!-- 挽留永久优惠券弹窗 -->
    <eveVipMoneyPop @showPayRetainPop="showPayRetainPop" ref="eveVipMoneyPopref"></eveVipMoneyPop>
<!--     <div class="moniBtn" @click="showPayRetainPop1">升级永久测试</div>-->
     <!-- opt技术弹窗 -->
     <optTechnical></optTechnical>
  </div>
</template>
<script type="text/ecmascript-6">
import Login from '@/components/Login'
import BindPhone from '@/components/BindPhone'
import CodeExchange from '@/components/CodeExchange'
import AttenDance from '@/components/AttenDance'
import toastVip from '@/components/ToastVip'
import NewLoginPanel from '@/components/NewLoginPanel'
import PlayVideo from '@/components/PlayVideo.vue';
import HdProvisionalUpgrade from '@/components/HdProvisionalUpgrade'
import RightFunPop from "@/components/RightFunPop.vue"
import WelcomeAd from "@/components/Welcome_ad.vue"
import LocalCache from "@/stores/cache.js"
import AIpromptWords from "COMPONENTS/AIpromptWords.vue";
import YouhuiPop from '@/components/YouhuiPop.vue'
import isEveVipPop from '@/components/isEveVipPop.vue'
import congratulations_on_becoming from '@/components/congratulations_on_becoming.vue'
import eveVipMoneyPop from '@/components/eveVipMoneyPop.vue'
import optTechnical from '@/components/optTechnical.vue'
import utils from '../utils'

export default {
  components: {
    isEveVipPop,
    YouhuiPop,
    Login,
    BindPhone,
    CodeExchange,
    AttenDance,
    toastVip,
    NewLoginPanel,
    PlayVideo,
    HdProvisionalUpgrade,
    RightFunPop,
    WelcomeAd,
    AIpromptWords,
    congratulations_on_becoming,
    eveVipMoneyPop,
    optTechnical,
  },
  data() {
    return {
      tabList: [
        {name: "广场", link: "/square", icon: "/static/img/gallery.png", active_icon: "/static/img/gallery_active.png"},
        {
          name: "创作",
          link: "/runway",
          icon: "/static/img/creation.png",
          active_icon: "/static/img/creation_active.png"
        },
        {name: "工具箱", link: "/toollist", icon: "/static/img/tool.png", active_icon: "/static/img/tool_active.png"},
        // {
        //   name: "会员",
        //   link: "/member",
        //   icon: "/static/img/02.gif",
        //   active_icon: "/static/img/02.gif"
        // },
        {name: "我的", link: "/mine", icon: "/static/img/mine.png", active_icon: "/static/img/mine_active.png"},
      ],
      welcomePopup: false,
    }
  },
  created() {



    this.fetchProfile()
    console.log('this.$route.path',this.$route.path)
    if (this.$route.path.includes('square')) {
      // 媒体ID
      let ttl = 120 * 60 * 1000
      if (this.$route.query.adaid) {
        LocalCache.setCache("ad_account_id", this.$route.query.adaid, ttl)
      }
      if (this.$route.query.adsid) {
        LocalCache.setCache("site_id", this.$route.query.adsid, ttl);
      }
      
      if (this.$route.query.bd_vid) {
        LocalCache.setCache("bd_vid", this.$route.query.bd_vid, ttl)
      }
      if (this.$route.query.msclkid) {
        LocalCache.setCache("msclkid", this.$route.query.msclkid, ttl)
        LocalCache.setCache("bd_vid", this.$route.query.msclkid, ttl)
      }
      if (this.$route.query.qhclickid) {
        LocalCache.setCache("qhclickid", this.$route.query.qhclickid, ttl)
      }

      let token = this.$route.query.token || '';
      if (token) {
        localStorage.setItem("token", token);
      }

      //判断url中是否带有token
      let resu = location.href.indexOf('token')
      if (resu > 0 || location.href.indexOf('tgad') > 0 || location.href.indexOf('adaid') > 0) {
        this.$router.push("/square")
      }
    }
    if (this.$route.path.includes('tuiguang')) {
      // 推广
      setTimeout(() => {
        this.$refs.welcomeAdPopup.show()
      });

      // 媒体ID
      let ad_account_id = this.$route.query.adaid || AD_AID // 媒体ID
      let site_id = this.$route.query.adsid || "" // 推广关键词ID
      let ttl = 120 * 60 * 1000
      if (this.$route.query.adsid) {
        LocalCache.setCache("site_id", site_id, ttl);
      }
      let keyword = ""
      // 搜索关键词
      LocalCache.setCache("keyword", this.$route.query.q || '');
      // 百度广告参数
      LocalCache.setCache("bd_vid", this.$route.query.bd_vid || '');
      // 360搜索推广参数
      LocalCache.setCache("qhclickid", this.$route.query.qhclickid || '');
      // 360展示广告参数
      LocalCache.setCache("sourceid", this.$route.query.sourceid || '');
      // 日期参数
      LocalCache.setCache("timestamp", this.$route.query.timestamp || '');

      var referrer = document.createElement('a');
      referrer.href = document.referrer;
      if (referrer.href) {
        let ref_params = this.getUrlParams(referrer.href)
        keyword = ref_params.q || ''
        if (keyword) {
          keyword = decodeURI(keyword)
        }
        LocalCache.setCache("keyword", keyword);
      }
      if (referrer.href.indexOf("so.com") > 1) {
        // 360 广告
        LocalCache.setCache("tgad", "111", ttl);
      } else if (referrer.href.indexOf("baidu.com") > 1) {
        // 百度 广告
        LocalCache.setCache("tgad", "122", ttl);
      }
      // 提交搜索词
      let user_id = localStorage.getItem("user_id") || 0;
      this.$http.post(`${MAIN_URLROOT}/wap/jsstat/adacount/record/`, {
        user_id: user_id,
        keyword: keyword,
        ad_account_id: ad_account_id,
        site_id: site_id,
        referrer: referrer.href,
        bd_vid:  this.$route.query.bd_vid,
        qhclickid:  this.$route.query.qhclickid,
        msclkid:  this.$route.query.msclkid
      })
    }
  },
  computed: {
    show_login_compoments() {
      return this.$store.state.show_login_compoments
    },
    show_code_exchange_compoments() {
      return this.$store.state.show_code_exchange_compoments
    },
    show_bindphone_compoments() {
      return this.$store.state.show_bindphone_compoments
    },
    show_attendance_compoments() {
      return this.$store.state.show_attendance_compoments
    },
    show_toast_vip() {
      return this.$store.state.show_toast_vip
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  isInputValshow() {
    return this.$store.state.isInputValshow;
  },
    userInfo() {
      return this.$store.state.userInfo;
    },
    vip_congratulations_show(){
      return this.$store.state.vip_congratulations_show
    }

},
  methods: {
    // 显示支付挽留弹框
    showPayRetainPop1(){

      // setInterval(() => {
        this.$store.commit('setFisYouh',true)
      //
      // }, 1000)
    },
    // 显示支付挽留弹框
    showPayRetainPop(){
      let up_id = `${this.userInfo.vip_type}-1`
      // if(localStorage.getItem('ling2')){
      //   up_id = '2-1'
      // }
      this.$http.get('/front/aivideo/pay/today_order/',{params:{
        upgrade_id:up_id //领完50 1_1 领完100 2_1
      }}).then(res => {
        this.$store.commit('setNewPayPop', true)
        this.$store.commit('setYouhuiPayDeail', res.data)
      })
    },
    toUpeveVip(data) {
      console.log('执行船只');
      // this.$store.commit('setcomVipShow',true)
      this.$store.commit('setNewPayPop', true)
      // UpgradePopup.value.setNewShow()
      this.$refs.UpgradePopup.setNewShow()

    },
    checkTimestamp() {
      // 是永久会员直接return
      // youhuiPopRef.value.setIsSHow(false, 0)
      this.$store.commit('setIsYouhuiPopshow', false)
      this.$store.commit('set_type', 0)
      if (this.userInfo.vip_type == 5) {
        this.$store.commit('setIsYouhuiPopshow', false)
        this.$store.commit('set_type', 0)
        return
      }

      let isTodyYouh = localStorage.getItem('isTodyYouh')
      let youhuiStatus = false
      if (isTodyYouh) {
        let start_time = isTodyYouh
        const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数

        const currentTime = Date.now();

        // 计算时间差
        const timeDiff = currentTime - parseInt(start_time, 10);
        let clientDownDate = localStorage.getItem('isTodyYouh') || 0
        // 超过12小时执行操作
        if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
          localStorage.removeItem('isTodyYouh')
          youhuiStatus = true
        } else {
          youhuiStatus = true
        }
      } else {
        youhuiStatus = false
      }

      console.log(youhuiStatus)
      // payKeStore.checkoutKePop()
      // store.dispatch('checkIsPay',http)
      this.$http.get('/front/aivideo/pay/today_order/').then(res => {
        if (res.status == 200) {
          // commit('setYouhuiPayDeail', res.data);
          // commit('setNewPayPop', res.data);
          // 永久会员升级悬浮显示
          // youhuiPopRef.value.setIsSHow(true, 2)
          this.$store.commit('setIsYouhuiPopshow', true)
          this.$store.commit('set_type', 2)
        } else {
          // 永久会员优惠悬浮显示
          if (youhuiStatus) {
            console.log(1)
            // youhuiPopRef.value.setIsSHow(true, 1)
            this.$store.commit('setIsYouhuiPopshow', true)
            this.$store.commit('set_type', 1)
          }

        }
      }).catch(err => {
        if (youhuiStatus) {
          // youhuiPopRef.value.setIsSHow(true, 1)
          this.$store.commit('setIsYouhuiPopshow', true)
          this.$store.commit('set_type', 1)
          return
        }
        //悬浮消失
        // youhuiPopRef.value.setIsSHow(false, 0)
        this.$store.commit('setIsYouhuiPopshow', false)
        this.$store.commit('set_type', 0)

      })
    },
    getUrlParams(url) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split('?')[1]
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      if (urlStr) {
        let paramsArr = urlStr.split('&')
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          // 再通过 = 将每一个参数分割为 key:value 的形式
          let arr = paramsArr[i].split('=')
          obj[arr[0]] = arr[1];
        }
      }
      return obj
    },
    toPlay(name) {
      if (!this.isLogin) {
        this.$store.commit('setShowLogin', true)
        return
      }
      if(name == 'member') {
        this.$router.push('/member')
      }else{
        this.$store.commit('showVideoPop', true)
        this.$store.commit('videoPlayUrl', 'https://cdnjindouyuan202105.m.nengshuohuihua.com/ad/c39bbcfd0dceb044f81e21030a74e360.mp4')
        this.$refs.playVidRef.playVid()
      }

    },
    checkoutKePop() {
      // state.kekePop = true
      // this.$store.commit('kekePopSet', true)
      let keTimer = null
      const vipForever = localStorage.getItem("vip_time") || 0;
      if (vipForever == 0) {
        let kehuInfo2 = localStorage.getItem('payTip')
        if (kehuInfo2) {
          kehuInfo2 = JSON.parse(kehuInfo2)
          let start_time2 = kehuInfo2.time
          const TWELVE_HOURS2 = 12 * 60 * 60 * 1000; // 12小时的毫秒数
          const currentTime2 = Date.now();

          // 计算时间差
          const timeDiff2 = currentTime2 - parseInt(start_time2, 10);
          if (timeDiff2 >= TWELVE_HOURS2) {//大于12个小时

          } else {
            return
          }
        }
      } else {
        console.log('!!!0')
        let kehuInfo = localStorage.getItem('vip_time')
        kehuInfo = JSON.parse(kehuInfo)
        let start_time = kehuInfo
        const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
        const currentTime = Date.now();

        // 计算时间差
        const timeDiff = currentTime - parseInt(start_time, 10);

        // 超过12小时执行操作
        if (timeDiff >= TWELVE_HOURS) {
          console.log(1111)
          //state.kekePop = true
          this.$store.commit('kekePopSet', true)
          localStorage.setItem('vip_time', Date.now())
          return
        }

      }
      // if(!localStorage.getItem('payTip')) return
      this.$http.post('/front/aivideo/huodong/chongzhi/', {vip_type: 5, APP_ID: APP_ID}).then(res => {
        if (res.data.pay_url) {
          //state.kekePop = true
          let kehuInfo2 = localStorage.getItem('payTip')
          if (kehuInfo2) {
            kehuInfo2 = JSON.parse(kehuInfo2)
            let start_time2 = kehuInfo2.time
            const TWELVE_HOURS2 = 12 * 60 * 60 * 1000; // 12小时的毫秒数
            const currentTime2 = Date.now();

            // 计算时间差
            const timeDiff2 = currentTime2 - parseInt(start_time2, 10);
            if (timeDiff2 >= TWELVE_HOURS2) {//大于12个小时

            } else {
              return
            }
          }
          this.$store.commit('kekePopSet', true)
          localStorage.setItem('payTip', JSON.stringify({time: Date.now()}))
          clearInterval(keTimer)
        } else {
          // if(!localStorage.getItem('payTip')) return
          keTimer = setInterval(() => {
            this.$http.post('/front/aivideo/huodong/chongzhi/', {vip_type: 5, APP_ID: APP_ID}).then(res => {
              if (res.data.pay_url) {
                //state.kekePop = true
                this.$store.commit('kekePopSet', true)
                localStorage.setItem('payTip', JSON.stringify({time: Date.now()}))
                clearInterval(keTimer)
              } else {
                let kehuInfo = localStorage.getItem('payTip')
                kehuInfo = JSON.parse(kehuInfo)
                let start_time = kehuInfo.time
                const TWELVE_HOURS = 600000; // 十分钟的毫秒数
                const currentTime = Date.now();

                // 计算时间差
                const timeDiff = currentTime - parseInt(start_time, 10);
                if (timeDiff >= TWELVE_HOURS) {
                  clearInterval(keTimer)
                }
              }
            }).catch(res => {
              clearInterval(keTimer)
            })
          }, 3000)
        }
      }).catch(res => {
        clearInterval(keTimer)
      })

    },
    fetchProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
          // this.checkTimestamp()
          if (localStorage.getItem('_goPay')){
            // alert(localStorage.getItem('_goPay'))
            localStorage.removeItem('_goPay')
            if (this.userInfo.vip_typ!=5){
              this.showPayRetainPop()
            }
          }
          if(localStorage.getItem('ling1')||localStorage.getItem('ling2')){
              let localTime = localStorage.getItem('formattedTime')
              // let localTime = Date.now() - 1
              if(localTime){
                // 10分钟过期
                if (Date.now() - localTime >= 10*60*1000) {
                  console.log('要清理');
                  localStorage.removeItem('formattedTime')
                  // this.$store.commit('setVipYouhuiHeaderShow',)
                  if(localStorage.getItem('paynum')){
                    this.$store.commit('setIsYouhuiPopshow', true)
                    this.$store.commit('setHeader_r_show',1)
                  }else{
                    this.$store.commit('setIsYouhuiPopshow', false)
                  }
                }else{
                  //左下角悬浮显示
                  this.$store.commit('setIsYouhuiPopshow', true)
                  this.$store.commit('setHeader_r_show',2)
                }
              }else{
                if(localStorage.getItem('paynum')){
                  //左下角悬浮显示
                  this.$store.commit('setIsYouhuiPopshow', true)
                  this.$store.commit('setHeader_r_show',1)
                }
              }
          }else{
            //如果存在paynum
            //左下角悬浮显示
            if(localStorage.getItem('paynum')){
              this.$store.commit('setIsYouhuiPopshow', true)
              this.$store.commit('setHeader_r_show',1)
            }
          }
          //检测第一次创作时间是否过0点
          if(utils.getIsZeroTime('isFirstCreat')){
            localStorage.removeItem('isFirstCreat')
          }
        }
      }).catch(err=>{
        // localStorage.clear()
        localStorage.removeItem('isTodyYouh')
        localStorage.removeItem('getY')
        localStorage.removeItem('paynum')
        var ua = navigator.userAgent.toLowerCase()
          if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
            //如果当前路由是linkus
            if(this.$route.path != '/linkus'){
              // 微信自动登录
              window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
            }
          }
      }).finally(() => {

      })
    },
    vipOpenHandle() {
      this.$router.push("/member");
      // 开通会员
      // this.$store.commit('setShowOpen', true)
    }
  },
  mounted() {
    // this.$store.commit('setFisYouh', true)
    // this.checkoutKePop()
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#layout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .main {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;

    .head {
      padding: 20px 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #000;
      //box-shadow: 0 1px 10px 0px #575757;
      // border-bottom: 1px solid #333;
      .logo {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;

        img {
          width: 20px;
          border-radius: 3px;
          overflow: hidden;
          margin: 0 10px 0 0;
        }

        .logoName {
          width: 60px;
          height: 24px;
          background: linear-gradient(to right, #f92c65, #9f2bf9);
          color: #fff;
          font-weight: 700;
          border-radius: 24px;
          // text-align: center;
          margin-left: 10px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 0;
        }
      }

      .objMv {
        display: flex;
        align-items: center;

        .videoImg {
          font-size: 0;
          width: 16px;
          height: 16px;
        }

        .objName {
          line-height: 0;
          color: #fff;
          font-size: 14px;
          position: relative;
          margin-left: 5px;
          font-weight: 600;

          .objHot {
            // height: 15px;
            position: absolute;
            right: 0;
            top: -25px;
          }
        }
      }
      .head_right{
        display: flex;
        align-items: center;
        .objMv {
          display: flex;
          align-items: center;
          &.mR10{
            margin-right: 10px;
          }

          .videoImg {
            font-size: 0;
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          .videoGif {
            font-size: 0;
            width: 24px;
            height: 24px;
          }

          .objName {
            line-height: 1;
            color: #fff;
            font-size: 14px;
            font-weight: 600;
          }
        }
      }

    }
  }

  .tabbar {
    height: 60px;
    flex-shrink: 0;
    width: 100%;
    background-color: #1a1a1a;

    .tab_item {
      font-size: 12px;
      flex-direction: column;
      flex: 1 1 0%;
      color: #949ba4;

      &.active {
        .tab_icon {
          display: none;

          &.tab_active_icon {
            display: block;
          }
        }
      }

      .tab_icon {
        width: 25px;
        height: 25px;
        margin-bottom: 5px;
        display: block;

        &.tab_active_icon {
          display: none;
        }
      }
    }

    .vip {
      color: #dfb589;
    }

  }
}


</style>